import { SettingsProps } from "./types";
import { renderWidget } from "../renderWidget";

export const Settings: React.FC<SettingsProps> = ({
  campaignData = {},
  objectData = {},
  setCampaignData,
  setObjectData,
  unitName = "Funnel",
  widgets = ["name", "planner", "domain", "scripts", "delete"],
}) => {
  return (
    <div className="flex flex-col gap-7">
      {widgets.map((widget, key) => {
        return (
          <span key={key}>
            {renderWidget(widget, { objectData, campaignData, setCampaignData, setObjectData, unitName })}
          </span>
        );
      })}
      <div />
    </div>
  );
};
